module.exports = __webpack_public_path__ + "img/400.room_link.89a967ca.svg";